import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Flex } from "antd";
import InputField from "../../../Reuseable/InputField/InputField";
import CustomSelect from "../../../Reuseable/Select/Select";
import "./PermissionEditModal.scss";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CustomNotification from "../../../Reuseable/CustomNotification/CustomNotification";
import { fetchPermissionList } from "../../../store/permissionSlice";

// const { Option } = Select;

const PermissionEditModal = ({
  open,
  onClose,
  userData = {},
  onSave,
  editablePermission,
  bankListOption,
  productListOption,
  areaCodeListOption,
  bucketOptions,
  languageOptions,
}) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({
    id: editablePermission?.key,
    team: null,
    bucket: null,
    language: null,
    bank: [],
    product: [],
    area: [],
  });

  const handleChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };



  useEffect(() => {
    if (editablePermission) {
      setFormValues({
        id: editablePermission.key,
        team: editablePermission.name,
        bucket: editablePermission.bucket,
        language: editablePermission.language,
        bank: editablePermission.portfolio?.map((item) => item.id),
        product: editablePermission.product?.map((item) => item.id),
        area: editablePermission.area?.map((item) => item.id),
      });
    }
  }, [editablePermission]);

  const handleEditPermission = async () => {
    const payload = {
      id: editablePermission?.key,
      bucket: formValues.bucket,
      portfolio: formValues.bank,
      product: formValues.product,
      area: formValues.area,
      language: formValues.language,
    };

    try {
      const res = await axios.patch("agency/admin/permissions-list/", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.status === 200) {
        CustomNotification.show("Permission updated successfully!", "success");
        onClose()
        dispatch(fetchPermissionList());
      }
    } catch (error) {
      CustomNotification.show("Error creating permission", "error");
      console.error(error);
      onClose()
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable
      destroyOnClose
      className="permission-edit-modal"
    >
      <h3 className="modalTitle">
        Edit User Permission <span>of Eleanor Pena</span>
      </h3>
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          name: userData?.name,
          address: userData?.address,
          operationalAreas: userData?.area,
          mobile: userData?.mobile,
        }}
      >
        <Flex className="select-and-input">
          <Flex className="select-item">
            <CustomSelect
              label="Banks"
              placeholder="Select Bank"
              value={formValues.bank}
              options={bankListOption}
              onChange={(value) => handleChange("bank", value)}
              isMultiSelect={true}
            />
            <CustomSelect
              label="Products"
              placeholder="Select Product"
              value={formValues.product}
              options={productListOption}
              onChange={(value) => handleChange("product", value)}
              isMultiSelect={true}
            />
            <CustomSelect
              label="Operational Areas"
              placeholder="Select Area"
              value={formValues.area}
              options={areaCodeListOption}
              onChange={(value) => handleChange("area", value)}
              isMultiSelect={true}
            />
          </Flex>
          <Flex className="inputs">
            <CustomSelect
              placeholder=" select"
              label="Bucket Range Start"
              className="formSelect"
              value={formValues.bucket}
              options={bucketOptions}
              onChange={(value) => handleChange("bucket", value)}
            />
            <CustomSelect
              placeholder="select"
              label="Language"
              className="formSelect"
              value={formValues.language}
              options={languageOptions}
              onChange={(value) => handleChange("language", value)}
            />
          </Flex>
        </Flex>

        <Form.Item>
          <NormalButton
            type="primary"
            className="saveDetailsBtn"
            onClick={handleEditPermission}
          >
            Save Details
          </NormalButton>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PermissionEditModal;
